@import './pn-mainnav-common.scss';
@import '../../../globals/main.scss';

pn-mainnav-level {
  display: block;
  &:not(.hydrated) {
    max-height: 5.6rem;
    overflow: hidden;
  }
  &[data-level='1'] {
    width: 100%;
    right: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    flex: 1;

    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      width: auto;
      overflow: initial;

      // Only works for blink/webkit
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  &[data-level='2'] {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 0;
    background-color: $white;
    z-index: 1;
    transform: translateX(100vw);
    transition: transform 0.2s 0s;
    transition-property: transform, visibility;
    overflow: scroll;
    visibility: hidden;

    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      left: 0;
      top: calc(100% + 1rem);
      bottom: auto;
      border-radius: 1.6rem;
      width: auto;
      padding: 1.6rem 1.6rem 0 1.6rem;
      -webkit-box-shadow: $mainmenu-shadow-elevation8;
      -moz-box-shadow: $mainmenu-shadow-elevation8;
      box-shadow: $mainmenu-shadow-elevation8;
      height: auto;
      z-index: 3;
      display: none;

      &[data-menuitem-rightaligned='true'] {
        // right-align next-to-last menu-pop-up on desktop (last is hidden mobile-action-menu)
        right: 0;
        left: unset;
      }
    }

    @media screen and (max-height: $mobilenav-media-phoneheight) {
      -ms-overflow-style: none; // IE and Edge
      scrollbar-width: none; // Firefox

      &::-webkit-scrollbar {
        // Chrome, Safari and Opera
        display: none;
      }
    }

    &[aria-hidden='false'] {
      transform: translateX(0);
      visibility: visible;

      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        display: block;
        overflow: visible;

        &:not([data-level-listcount='1']) {
          display: grid;
          grid-template-columns: minmax(12em, 20em) 1fr;
          grid-template-rows: auto auto;
          gap: 0px 1.6rem;
          grid-template-areas:
            'top top'
            'left right';
        }
      }
    }
    &[data-level-alignment='left'] {
      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        right: 0;
        left: unset;
      }
    }
    &[data-level-alignment='center'] {
      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        left: 50%;
        transform: translateX(-50%);
      }
    }
    a {
      color: $blue700;
      text-decoration: none;
    }
  }
  [slot='top'] {
    display: flex;
    @media screen and (min-width: $mobilenav-media-tablet) {
      display: none;
    }
  }

  [slot='footer'] {
    [data-menu-currentlevel='2'] & {
      display: none;
      overscroll-behavior: contain;
    }
  }
}

.mainnav-level-header {
  grid-area: top;
  > label {
    position: absolute;
    width: 0.1rem;
    height: 0.1rem;
    padding: 0;
    margin: -0.1rem;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
  }
  > button {
    display: block;
    position: relative;
    border: none;
    background-color: transparent;
    color: $blue700;
    padding: 2.4rem 0 2.4rem 6.2rem;
    width: 100%;
    text-align: left;

    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      display: none;
      speak: none;
    }

    > pn-icon {
      speak: none;
      position: absolute;
      height: 2.4rem;
      width: 2.4rem;
      left: 3rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  [data-level='2'] & {
    > pn-mainnav-link > a {
      font-size: 2.4rem;
    }
  }
}
